import { Link } from '@rocketlane/rocket-router';
import { Result } from 'antd';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import { ReactComponent as NotFoundSvg } from 'assets/svgs/404.svg';
import { Page as PageAtom } from 'components/molecules/page';
import { useTranslation } from 'hooks/use-translation';
import { useDismissBootSkeleton } from 'utils/dismiss-boot-skeleton';

const Page = styled(PageAtom)`
  justify-content: center;
`;

export const NotFound: FC<React.PropsWithChildren<unknown>> = () => {
  useDismissBootSkeleton();

  return (
    <Page $gray>
      <Helmet>
        <title data-cy="page.not.found.title">
          {useTranslation('error.404.title')}
        </title>
      </Helmet>
      <Result
        title={useTranslation('error.404.title')}
        icon={<NotFoundSvg />}
        subTitle={useTranslation('error.404.message')}
        extra={
          <Link to="/" type="primary">
            {useTranslation('error.404.action')}
          </Link>
        }
      />
    </Page>
  );
};
